export const basesPointToPercentage = (basesPoint: number) =>
  `${basesPoint / 100}%`;
